import { operations } from "types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";

type tooltips = operations["tooltips"];

/**
 * Получение подсказок по заявке
 * @description Получение подсказок по заявке (доступен для SENIOR_CUSTOMER, JUNIOR_CUSTOMER, SENIOR_LP, JUNIOR_LP, SENIOR_OPERATOR, JUNIOR_OPERATOR, RISK_MANAGER)
 */
export const getDmnTooltips = ({
  id,
}: tooltips["parameters"]["path"]): Promise<tooltips["responses"]["200"]["content"]["*/*"][]> => {
  return api.get(ENDPOINTS.getDmnTooltips(id));
};
